export const copy = url => {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    document.body.appendChild(input);
    input.setAttribute('value', url);
    input.setAttribute('display', 'none');
    input.select();
    if (document.execCommand('copy')) {
      document.execCommand('copy');
      resolve();
    } else {
      reject();
    }
    document.body.removeChild(input);
  });
};

export const down = url => {
  return new Promise((resolve, reject) => {
    if(typeof url !== 'string') {
      reject(new Error('请传入正确的链接'));
      return;
    } else if(!url) {
      reject(new Error('下载链接不能为空'));
      return;
    }
    var alink = document.createElement('a');
    document.body.appendChild(alink);
    alink.style.display = 'none';
    alink.href = url + '?response-content-type=application/octet-stream';
    alink.target = '_blank';
    alink.download = '';
    alink.click();
    alink.remove();
    resolve();
  });
};
